import type { CourseModule } from "@/core/types";
import { lektionEinrichten } from "./lektion-01-einrichten";
import { lektionAnzeigedauern } from "./lektion-02-anzeigedauern";

/**
 * Die Registerkarte „Bildschirmpräsentation“. Keine ihrer Einstellungen kommt
 * in Office.js vor; geprüft wird über die Prüfmakros, die SlideShowSettings
 * und SlideShowTransition auslesen.
 */
export const modulBildschirmpraesentation: CourseModule = {
  id: "bildschirmpraesentation",
  title: "Bildschirmpräsentation einrichten",
  summary:
    "Präsentationsarten vom Vortrag bis zum Kiosk, zielgruppenorientierte Fassungen, " +
    "eingeübte Anzeigedauern und aufgezeichnete Präsentationen.",
  level: "Aufbau",
  lessons: [lektionEinrichten, lektionAnzeigedauern],
};
